import * as DecoTypesDeclaration from '../Product/Product.DecoTypeDeclaration';
import * as ALCPricing from '../Product/Product.ALCPricing';
import * as ProductDecoTypes from '../Product/Product.DecoTypes';
import * as DecorationAddons from '../Product/Product.DecorationAddons';

declare global {
  var ALCPricing: any;
  var DecorationAddons: any;
}

// Document Ready
$(function() {
  console.log("Product PDP Init - Started");
  console.log('Getting global configuration options');
  ProductDecoTypes.getGlobalProductOptionsConfiguration();

  if(Merchology.ProductDetails.isALCPricingProduct) {
    ALCPricing.showSelectedDecorationFees();
  }

  DecorationAddons.initDecorationAddons();

  console.log("Product PDP Init - Done");

  window.ALCPricing = {};
  window.ALCPricing.addProductOptionsLineitemsToCart =  ALCPricing.addProductOptionsLineitemsToCart;
  window.ALCPricing.getFeeVariants = ALCPricing.getFeeVariants;

  window.DecorationAddons = {};
  window.DecorationAddons.prepareCartItem = DecorationAddons.prepareDecorationAddonCartItem;
  window.DecorationAddons.addToCart = DecorationAddons.addSelectedDecorationAddonToCart;
});
